function parseVersion(value: string) {
  return value.split(".").map((part) => Number.parseInt(part, 10));
}

function compareVersionParts(left: number[], right: number[]) {
  const maxLength = Math.max(left.length, right.length);
  for (let index = 0; index < maxLength; index += 1) {
    const leftPart = left[index] ?? 0;
    const rightPart = right[index] ?? 0;
    if (leftPart === rightPart) {
      continue;
    }
    return leftPart > rightPart ? 1 : -1;
  }
  return 0;
}

export function isWalSafe(sqliteVersion: string) {
  const current = parseVersion(sqliteVersion);
  return (
    compareVersionParts(current, parseVersion("3.52.0")) >= 0 ||
    (compareVersionParts(current, parseVersion("3.51.3")) >= 0 &&
      compareVersionParts(current, parseVersion("3.52.0")) < 0) ||
    (compareVersionParts(current, parseVersion("3.50.7")) >= 0 &&
      compareVersionParts(current, parseVersion("3.51.0")) < 0)
  );
}
